import { render, staticRenderFns } from "./w-panel.vue?vue&type=template&id=1a9fd57b&"
import script from "./w-panel.vue?vue&type=script&lang=ts&"
export * from "./w-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports